import { z } from 'zod';

// queue #663 §UAT-2026-07-09-R663 §R663-3: 피드백/문의 제출 폼 스키마.
// BE @Size(max=4000) 와 정합.

const FEEDBACK_KINDS = ['QUESTION', 'BUG', 'IMPROVEMENT'] as const;

export const feedbackCreateSchema = z.object({
  kind: z.enum(FEEDBACK_KINDS, {
    errorMap: () => ({ message: '유형을 선택해 주세요' }),
  }),
  body: z
    .string()
    .min(1, '내용을 입력해 주세요')
    .max(4000, '4000자를 초과할 수 없습니다'),
  moduleCode: z.string().nullable().optional(),
});

export type FeedbackCreateFormValues = z.infer<typeof feedbackCreateSchema>;

// queue #684 §UAT-2026-07-14-R684 §R684-4(a): 관리 답변 다이얼로그 — 답변 본문 필수(1~4000자).
// BE @NoXss @Size(max=4000) 와 정합(answer 는 @NotBlank 미부착 · 조건부 필수는 FE zod + BE service 이중 방어).
export const feedbackAnswerSchema = z.object({
  answer: z
    .string()
    .min(1, '답변 내용을 입력하세요')
    .max(4000, '4000자를 초과할 수 없습니다'),
});

export type FeedbackAnswerFormValues = z.infer<typeof feedbackAnswerSchema>;
